import { z } from 'zod'
import { uploadFileDataSchema } from './upload-file-data'

/** 禮遇項目圖片 Schema */
export const managerBenefitFileSchema = z
  .object({
    /** 首圖 */
    index: z.boolean(),
    /** 排序 */
    sort: z.number().optional()
  })
  .merge(uploadFileDataSchema)

/** 禮遇項目圖片 */
export interface ManagerBenefitFile
  extends z.infer<typeof managerBenefitFileSchema> {}
